import React, { useState } from 'react';
import { TabGridContianer } from './AccountDetailTab.styled';
import AccountDetailTabList from './AccountDetailTab';
import { isLandscape } from 'src/utils/util';
import { useSelector } from 'react-redux';
import { JAPAN_SALESORG } from 'src/constants/appConstants';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const AccountDetailTabListContainer = ({
    accountDetailTabList,
    tabActiveId,
    tabSwitch,
}) => {
    const [landscapeMode, setLandscapeMode] = useState(isLandscape());
    
    const hybrisUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    
    const isJapanUser =
        hybrisUserDetails?.englishPreferred != 'Y' &&
        hybrisUserDetails?.languageISOCode === 'ja' &&
        hybrisUserDetails?.salesOrgs &&
        hybrisUserDetails?.salesOrgs[0] === JAPAN_SALESORG;
    
    useEffectWithErrorLogging(() => {
        const handleOrientationChange = () => {
            setLandscapeMode(isLandscape());
        };

        window.addEventListener('orientationchange', handleOrientationChange);
        window.addEventListener('resize', handleOrientationChange);

        return () => {
            window.removeEventListener('orientationchange', handleOrientationChange);
            window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    return (
        <>
            <TabGridContianer isLandscape={landscapeMode}>
                {accountDetailTabList.map((accountTab) => {
                    return (
                        <AccountDetailTabList
                            key={accountTab.id}
                            label={accountTab.label}
                            id={accountTab.id}
                            isTabActive={tabActiveId === accountTab.id}
                            tabSwitch={tabSwitch}
                            isJapanUser={isJapanUser}
                        />
                    );
                })}
            </TabGridContianer>
        </>
    );
};

export default AccountDetailTabListContainer;